import { registerComponent } from '@gig/magic-common';
import RadioGroupComponent from './radio-group.vue.js';

var RadioGroup = registerComponent(RadioGroupComponent);

export { RadioGroup };
